var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2471_11899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22Z",
    fill: "#03C75A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8599 22.5657L18.9094 14.0381H13.9751V29.9619H19.1399V21.4343L25.0903 29.9619H30.0246V14.0381H24.8599V22.5657Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2471_11899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaver);
export default __webpack_public_path__ + "static/media/naver.d0c52b193967111de8c8a6358fc17410.svg";
export { ForwardRef as ReactComponent };